if (!customElements.get("swatch-product")) {
  customElements.define(
    "swatch-product",
    class SwatchProduct extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if(this.dataset.skip) return;
        this.addEventListener("click", async (e) => {
          e.preventDefault();
          const handle = this.querySelector("a").dataset.handle;
          const res = await fetch(
            `/products/${handle}?sections[]=sections--26619970912641__api-content-card`
          );
          const data = await res.json();
          const html = new DOMParser().parseFromString(data["sections--26619970912641__api-content-card"],"text/html");
          this.closest("product-card").outerHTML = html.querySelector("product-card").outerHTML;
        });
      }
    }
  );
}